import { useReadContract } from "wagmi";
import { KING_OF_HILL_ABI, KING_OF_HILL_ADDRESS } from "../contractConfig";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Crown, Trophy } from "lucide-react";
import { polygon } from "viem/chains";

interface LeaderboardEntry {
  address: string;
  timeAsKing: string;
  totalContributions: string;
}

export const Leaderboard = () => {
  const { data: leaderboardData } = useReadContract({
    address: KING_OF_HILL_ADDRESS,
    abi: KING_OF_HILL_ABI,
    functionName: "getLeaderboard",
    chainId: polygon.id,
  });

  const formatAddress = (address: string) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-center gap-2">
          <Trophy className="h-5 w-5 text-yellow-500" />
          Leaderboard
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {leaderboardData?.map((entry: LeaderboardEntry, index: number) => (
            <div
              key={entry.address}
              className="flex items-center justify-between p-3 rounded-lg bg-secondary/50"
            >
              <div className="flex items-center gap-3">
                <span className="text-lg font-semibold">#{index + 1}</span>
                {index === 0 && <Crown className="h-4 w-4 text-yellow-500" />}
                <span className="font-mono">{formatAddress(entry.address)}</span>
              </div>
              <div className="text-sm text-muted-foreground">
                <div>{entry.timeAsKing}</div>
                <div>{entry.totalContributions} MATIC</div>
              </div>
            </div>
          ))}
          {(!leaderboardData || leaderboardData.length === 0) && (
            <p className="text-center text-muted-foreground">
              No kings have claimed the throne yet
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};